<template>
    <div>
        <a
            :href="
                appleLinkOverride
                    ? appleLinkOverride
                    : 'https://itunes.apple.com/ca/app/mini-dayz-survival-game/id1141343378?mt=8'
            "
            class="butn--play"
        >
            <img src="/static/img/apple_icon.svg" alt="Download on the App Store" class="img-responsive" />
        </a>
        <a
            v-if="!appleOnly"
            :href="
                googleLinkOverride
                    ? googleLinkOverride
                    : 'https://play.google.com/store/apps/details?id=com.bistudio.minidayz'
            "
            class="butn--play"
        >
            <img src="/static/img/google_icon.svg" alt="Get it on Google Play" class="img-responsive" />
        </a>
    </div>
</template>

<script>
import { GAME_PAGE_NAME } from "../../../router/names";
export default {
    name: "PlayButtons",
    props: {
        appleOnly: { type: Boolean, default: false },
        appleLinkOverride: { type: String, default: null },
        googleLinkOverride: { type: String, default: null },
    },
    data() {
        return {
            GAME_PAGE_NAME,
        };
    },
    computed: {
        isMobile() {
            return this.$store.state.settings.isMobile;
        },
    },
};
</script>
